var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { ENV, URL_POST_METRICS } from "../utils/settings";
import { browserDetect } from "../utils/browserDetect";
import { uuid } from "../utils/helper";
const mode = "cors";
const credentials = "same-origin";
class MetricsApi {
    constructor() {
        this.timeToDownloadLastSegment = 0;
        this.currentCdn = "";
        this.level = -1;
        this.axios = axios.create();
    }
    // Data about hls frags loaded.
    hlsFragLoaded(_e, obj) {
        var _a;
        const frag = obj.frag;
        if (frag.stats && frag.stats.loading && frag.stats.parsing) {
            /**
             * Calculates the time taken to download the last fragment by subtracting the
             * parsing end time from the loading start time.
             * The loading start time represents when the request for the segment started,
             * and the parsing end time represents when the segment was fully loaded.
             **/
            this.timeToDownloadLastSegment = frag.stats.parsing.end - frag.stats.loading.start;
            // Level quality of frag loaded.
            this.level = frag.level;
            this.currentCdn = ((_a = obj.networkDetails.responseURL.match(/https:\/\/([a-z-A-Z-0-9_.-]+)(\/.+)?/)) === null || _a === void 0 ? void 0 : _a[1]) || "";
        }
    }
    // Send metrics data to the database.
    reportMetrics(metrics, talk, emailSubscription) {
        return __awaiter(this, void 0, void 0, function* () {
            if (metrics.timers.watch == null || metrics.timers.watch <= 0) {
                return;
            }
            if (!localStorage.getItem(`analytics_id_${emailSubscription}`)) {
                localStorage.setItem(`analytics_id_${emailSubscription}`, uuid());
            }
            const metricsMetadata = {
                "time": new Date().getTime(),
                "talk_owner_id": talk.owner_id,
                "talk_id": talk.id,
                "consumer_id": -1,
                "username": emailSubscription && emailSubscription.split("@")[0],
                "email": emailSubscription,
                "fullname": "",
                "custom_var": "",
                "browser": browserDetect.browser,
                "browser_version": browserDetect.version,
                "os": browserDetect.OS,
                "cdnDomain": this.currentCdn,
            };
            metrics.id = localStorage.getItem(`analytics_id_${emailSubscription}`);
            metrics.extra.hlsLevel = this.level;
            metrics.timers.timeToDownloadLastSegment = this.timeToDownloadLastSegment;
            const url = URL_POST_METRICS;
            const dataToPost = {
                id: metrics.id,
                metadata: metricsMetadata,
                metrics: metrics,
            };
            try {
                const controller = new AbortController();
                const config = {
                    method: "post",
                    url: url,
                    headers: {
                        "Content-Type": "application/json"
                    },
                    data: dataToPost,
                    signal: controller.signal
                };
                if (ENV === "staging") {
                    config.credentials = credentials;
                    config.mode = mode;
                }
                yield this.axios.post(url, dataToPost, config);
            }
            catch (error) {
                console.error(error);
            }
        });
    }
}
export const metricsApi = new MetricsApi();
//# sourceMappingURL=metrics.js.map